package com.example.readingnotes.presentation.sales

import com.example.readingnotes.domain.usecase.GetSalesDashboardUseCase
import com.example.readingnotes.util.ErrorMessageProvider
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class SalesDashboardViewModel(
    private val getSalesDashboardUseCase: GetSalesDashboardUseCase,
    private val viewModelScope: CoroutineScope,
) {
    private val _state = MutableStateFlow(SalesDashboardState())
    val state: StateFlow<SalesDashboardState> = _state.asStateFlow()

    fun onEvent(event: SalesDashboardEvent) {
        when (event) {
            is SalesDashboardEvent.OnAppear -> loadDashboard()
            is SalesDashboardEvent.OnPeriodChange -> updatePeriod(event.period)
            is SalesDashboardEvent.OnRefresh -> refreshDashboard()
            is SalesDashboardEvent.OnClearError -> {
                _state.update { it.copy(errorMessage = null) }
            }
        }
    }

    private fun loadDashboard() {
        viewModelScope.launch {
            _state.update { it.copy(isLoading = true, errorMessage = null) }

            getSalesDashboardUseCase(tenantSlug = "default")
                .onSuccess { dashboard ->
                    _state.update {
                        it.copy(
                            isLoading = false,
                            dashboard = dashboard,
                            errorMessage = null,
                        )
                    }
                }.onFailure { error ->
                    _state.update {
                        it.copy(
                            isLoading = false,
                            errorMessage = ErrorMessageProvider.getLocalizedMessage(error, "売上データの読み込みに失敗しました"),
                        )
                    }
                }
        }
    }

    private fun updatePeriod(period: SalesPeriod) {
        _state.update { it.copy(selectedPeriod = period) }
        loadDashboard()
    }

    private fun refreshDashboard() {
        viewModelScope.launch {
            _state.update { it.copy(isRefreshing = true, errorMessage = null) }

            getSalesDashboardUseCase(tenantSlug = "default")
                .onSuccess { dashboard ->
                    _state.update {
                        it.copy(
                            isRefreshing = false,
                            dashboard = dashboard,
                            errorMessage = null,
                        )
                    }
                }.onFailure { error ->
                    _state.update {
                        it.copy(
                            isRefreshing = false,
                            errorMessage = ErrorMessageProvider.getLocalizedMessage(error, "売上データの更新に失敗しました"),
                        )
                    }
                }
        }
    }
}
